import { PagedInviteGridDto } from './../../../../core/models/invite-grid-model';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization, PagedOrganizationGridDto } from '../../../../core/models/organization-model';
import { NewOrganizationInviteComponent } from '../new-organization-invite/new-organization-invite.component';
import { DismissReason } from '../../../../shared/extensions/ng-active-modal/dismiss-reason';
import { InviteService } from 'src/app/core/services/api/invite.service';
import { Invite } from '../../../../core/models/invite-model';
import { TranslateService } from '@ngx-translate/core';
import { DialogModalComponent, IBasicModalComponentInstance, BasicModalOperationResult } from '../../../../shared/components/dialog-modal/dialog-modal.component';
import { UserStatus } from '../../../../core/models/enums/userStatus';
import { NotificationType } from '../../../../core/models/enums/notificationType';
import { BlockType } from '../../../../core/models/enums/blockType';
import { IWService } from '../../../../core/services/iw.service';
import { BlockUnblockService } from '../../../../core/services/api/blockunblock.service';
import { NotificationService } from '../../../../core/services/api/notification.service';
import { AuthInterceptor } from '../../../../core/handler/auth-interceptor';
import { Options } from 'src/app/shared/components/pagination/pagination.component';
import { OrganizationService } from '../../../../core/services/api/organization.service';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-organizations-grid',
  templateUrl: './organizations-grid.component.html',
  styleUrls: ['./organizations-grid.component.scss']
})
export class OrganizationsGridComponent implements OnInit {
  organizationGrid: PagedOrganizationGridDto = new PagedOrganizationGridDto();
  organizations: Organization[];
  organizationInvites: Invite[];
  organizationInvitesGrid: PagedInviteGridDto = new PagedInviteGridDto();
  showSpinner: boolean = true;
  submitting: boolean = false;
  userStatus = UserStatus;
  notificationType = NotificationType;
  blockUnblockType = BlockType;
  options: Options = {
    page: 1,
    size: 10
  };
  isVisible: boolean = false;
  constructor(
    private inviteService: InviteService,
    private modalService: NgbModal,
    public translate: TranslateService,
    public iwService: IWService,
    private notificationService: NotificationService,
    private blockUnblockService: BlockUnblockService,
    private organizationService: OrganizationService,
    private router: Router
  ) { }

  async ngOnInit() {
    await this.loadData(this.options.page, this.options.size);
    this.showSpinner = false;
  }

   loadData = async (page?: number, itemsPerPage?: number) => {
    this.organizationGrid = await this.organizationService.getOrganizationsWithRegisteredUsersAsync(page, itemsPerPage);
    this.organizations = this.organizationGrid.apiEnabledOrganizations.items;
   
  }

  async editUsersClick(organization: Organization) {
    const id = organization.code;

  const navigationExtras: NavigationExtras = {
    queryParams: { id: id },
  };

  }

  async addNewUser() {
    const modalRef = this.modalService.open(NewOrganizationInviteComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "lg",
    });
    var result = await modalRef.result;
    if (result == DismissReason.Saved) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }

    if (result == DismissReason.Cancelled) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }
  }

  shouldNotificationOptionBeShown(userInvite: Invite) {
    return (
      userInvite.currentStatus != this.userStatus.Registered &&
      userInvite.currentStatus != this.userStatus.Blocked &&
      userInvite.currentStatus != this.userStatus.ToBeConfirmed &&
      !userInvite.isCurrentUser
    );
  }

  isNotificationDisabled(userInvite: Invite) {
    return userInvite.currentStatus != this.userStatus.Notified;
  }

  async notifyUsers() {
    let notifiableInvites = this.organizationInvites.filter(
      (x) => x.shouldBeNotified == true
    );

    const inviteIds = notifiableInvites
      .map((userInvite) => userInvite.inviteId)
      .join(",");

    try {
      this.showSpinner = true;
      this.submitting = true;
      await this.notificationService.notify(
        inviteIds,
        Number(this.notificationType.User)
      );

      this.showSpinner = false;
      this.submitting = false;
      await this.showSuccessfulNotifyMessage();
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    } catch (error) {
      this.showSpinner = false;
      this.submitting = false;
      const modalInstance = this.modalService.open(DialogModalComponent)
        .componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = this.translate.instant("usersModule.notificationError");
      modalInstance.type = BasicModalOperationResult.Error;
      this.showSpinner = false;
    }
  }

 
  async isAnyBlockUnblockSignatureInProgress(
    inviteId: Number,
    maxRetries: number = 10,
    msRefreshTime: number = 5000,
    retry: number = 0
  ) {
    if (retry < maxRetries) {
      setTimeout(async () => {
        let currentInviteIndex = this.organizationInvitesGrid.apiEnabledInvites.items.findIndex(
          (obj) => obj.inviteId == inviteId
        );
        let currentInvite = this.organizationInvitesGrid.apiEnabledInvites.items.filter(
          (x) => x.inviteId == inviteId
        )[0];
        currentInvite = await this.inviteService.getInviteDetails(inviteId);
        this.organizationInvitesGrid.apiEnabledInvites.items[currentInviteIndex] = currentInvite;

        if (currentInvite.blockUnblockSignatureInProgress) {
          setTimeout(() => {
            this.isAnyBlockUnblockSignatureInProgress(
              inviteId,
              maxRetries,
              msRefreshTime,
              retry++
            );
          }, msRefreshTime);
        }
      }, msRefreshTime);
    }
  }

  async showSuccessfulNotifyMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.notifiedUsersTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.notifiedUsersBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  isPossibleToNotify() {
    if (!this.organizationInvites) return false;

    let notifiableInvites = this.organizationInvites.filter(
      (x) => x.shouldBeNotified == true && x.isCurrentUser == false
    );
    return notifiableInvites && notifiableInvites.length > 0;
  }

  shouldEliminateUserOptionBeShown(userInvite: Invite) {
    return (
      userInvite.currentStatus == this.userStatus.Pending &&
      !userInvite.isCurrentUser
    );
  }

  shouldBlockUnblockUserOptionBeShown(userInvite: Invite) {
    return (
      (userInvite.currentStatus == this.userStatus.Registered ||
        userInvite.currentStatus == this.userStatus.Blocked) &&
      !userInvite.isCurrentUser
    );
  }

  async removeUser(userInvite: Invite) {
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.eliminateUserTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.eliminateUserBody",
      { UserFullName: userInvite.fullName }
    );
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          await this.inviteService.delete(userInvite.inviteId);
          this.showSpinner = true;
          await this.loadData(this.options.page, this.options.size);
          this.showSpinner = false;
        },
      },
    ];
  }

  async blockUnblockUser(userInvite: Invite) {
    if (userInvite.blockUnblockSignatureInProgress) return false;

    let wallet = await this.iwService.getIW();

    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserTitle")
      : this.translate.instant("usersModule.blockUserTitle");
    modalInstance.body = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserBody", {
        UserFullName: userInvite.fullName,
      })
      : this.translate.instant("usersModule.blockUserBody", {
        UserFullName: userInvite.fullName,
      });
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          try {
            this.showSpinner = true;
            this.submitting = true;
            let blockUnblockResponse =
              await this.blockUnblockService.blockUnblockInvite(
                userInvite.inviteId,
                Number(this.blockUnblockType.User),
                !userInvite.isBlocked
              );

            wallet.cancelDialog = async () => {
              await this.blockUnblockService.rollBlockUnblockInviteSignContent(blockUnblockResponse.id);
              this.submitting = false;
              this.showSpinner = false;
            }

            wallet.walletLogout = async () => {
              await this.blockUnblockService.rollBlockUnblockInviteSignContent(blockUnblockResponse.id);
              localStorage.removeItem(AuthInterceptor.tokenName);
              window.location.reload();
            };

            await this.blockUnblockService.extrSignProcessBlockUnblockInvite(
              blockUnblockResponse.id,
              this.translate.currentLang
            );

            this.showSpinner = false;
            this.submitting = false;
            await this.showSuccessfulBlockUnBlockMessage(userInvite);
            await this.isAnyBlockUnblockSignatureInProgress(userInvite.inviteId);
            this.showSpinner = true;
            await this.loadData(this.options.page, this.options.size);
            this.showSpinner = false;
            wallet.cancelDialog = () => { }
            wallet.walletLogout = async () => {
              localStorage.removeItem(AuthInterceptor.tokenName);
              window.location.reload();
            };
          } catch (error) {
            alert(this.translate.instant("signatureErrorMessage"));
            this.showSpinner = false;
            this.submitting = false;
            wallet.cancelDialog = () => { }
            wallet.walletLogout = async () => {
              localStorage.removeItem(AuthInterceptor.tokenName);
              window.location.reload();
            };
          }
        },
      },
    ];
  }

  async showSuccessfulBlockUnBlockMessage(userInvite: Invite) {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.body = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserMessage", {
        UserFullName: userInvite.fullName,
      })
      : this.translate.instant("usersModule.blockUserMessage", {
        UserFullName: userInvite.fullName,
      });
    modalInstance.title = this.translate.instant("userUpdated");
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  blockUnblockMessageTooltipTitle(userInvite: Invite) {
    let message = "";
    if (userInvite.blockUnblockSignatureInProgress) {
      message = this.translate.instant("blockUnblockSignatureInProcess");
      return message;
    }

    message =
      userInvite.currentStatus == this.userStatus.Blocked
        ? this.translate.instant(
          "usersModule.unBlockUserTitle"
        )
        : this.translate.instant(
          "usersModule.blockUserTitle"
        );

    return message;
  }

  async confirmUser(userInvite: Invite) {
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.confirmUserTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.confirmUserBody",
      { UserFullName: userInvite.fullName }
    );
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          this.showSpinner = true;
          await this.iwService.addAssertionMethod(userInvite.userByOrganizationId);
          await this.loadData(this.options.page, this.options.size);
          this.showSpinner = false;
          await this.showSuccessfulConfirmUserMessage();
          await this.isConfirmUserIWSignatureInProgress(userInvite.inviteId);
        },
      },
    ];
  }

  async showSuccessfulConfirmUserMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.confirmUserInProgressTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.confirmUserInProgressBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  async isConfirmUserIWSignatureInProgress(
    inviteId: Number,
    maxRetries: number = 10,
    msRefreshTime: number = 5000,
    retry: number = 0
  ) {
    if (retry < maxRetries) {
      setTimeout(async () => {
        let currentInviteIndex = this.organizationInvitesGrid.apiEnabledInvites.items.findIndex(
          (obj) => obj.inviteId == inviteId
        );
        let currentInvite = this.organizationInvitesGrid.apiEnabledInvites.items.filter(
          (x) => x.inviteId == inviteId
        )[0];
        currentInvite = await this.inviteService.getInviteDetails(inviteId);
        this.organizationInvitesGrid.apiEnabledInvites.items[currentInviteIndex] = currentInvite;

        if (currentInvite.confirmUserIWSignatureInProgress) {
          setTimeout(() => {
            this.isConfirmUserIWSignatureInProgress(
              inviteId,
              maxRetries,
              msRefreshTime,
              retry++
            );
          }, msRefreshTime);
        }
      }, msRefreshTime);
    }
  }

  confirmUserMessageTooltipTitle(userInvite: Invite) {
    if (userInvite.confirmUserIWSignatureInProgress) {
      return this.translate.instant("usersModule.confirmUserInProgressBody");
    }
    return this.translate.instant("usersModule.confirmUserTitle");
  }
}
